import { Suspense, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/dev-style.css";
import "./assets/css/spacer.css";
import "./assets/css/style.css";
import { ThemeProvider } from "@mui/material/styles";
import { AppRouting } from "./shared/AppRouting";
import portalTheme from "./themes/App.theme";
import { useDispatch } from "react-redux";
import packageJson from "../package.json";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { BrowserRouter as Router } from "react-router-dom";

// const App: React.FC = () => (
//   <Suspense fallback={<Spinner />}>
//     <Loader />
//     <ThemeProvider theme={portalTheme}>
//       {/* <ErrorBoundary> */}
//       <AppRouting />
//       {/* </ErrorBoundary> */}
//     </ThemeProvider>
//   </Suspense>
// );

function App() {
  const dispath = useDispatch();
  // useEffect(() => {
  //   async function setUserState(params) {
  //     // console.log("params?.token", params?.token);
  //     instance.defaults.headers.common["Authorization"] = params?.token;
  //     await dispath(loginSuccess(params));
  //     // console.log(params);
  //   }
  //   // const data = await Storage.retrieveItem("userDetails");
  //   const data = localStorage.getItem("userDetails");
  //   if (data) {
  //     const userDetails = JSON.parse(data);
  //     setUserState(userDetails);
  //   }

  //   // Storage.retrieveItem("userDetails").then((params) => {
  //   //   console.log("Localstorage usetdata form app.tsx params", params);
  //   //   if (params === null || params === undefined || params === "") {
  //   //   } else {
  //   //     const userDetails = JSON.parse(params);
  //   //     console.log("Localstorage usetdata form app.tsx", userDetails);
  //   //     setUserState(JSON.parse(userDetails));
  //   //     // token = userDetails?.token;
  //   //   }
  //   // });

  //   // console.log("Localstorage usetdata", data);
  //   setUserState(JSON.parse(data));
  // }, [dispath]);

  useEffect(() => {
    // export default function emptyCache(){
    let version = localStorage.getItem("version");
    if (version !== packageJson.version) {
      if ("caches" in globalThis) {
        caches.keys().then((names) => {
          // Delete all the cache files
          names.forEach((name) => {
            caches.delete(name);
          });
        });

        // Makes sure the page reloads. Changes are only visible after you refresh.
        globalThis.location?.reload?.();
      }

      localStorage.clear();
      localStorage.setItem("version", packageJson.version);
    }
    // }
  }, []);

  /*
  useEffect(() => {
    try {
      if (
        globalThis.self &&
        globalThis.top &&
        globalThis.self !== globalThis.top
      ) {
        // Allow only if the iframe's origin is the same as the current origin
        if (
          document.referrer &&
          new URL(document.referrer).origin === globalThis.location?.origin
        ) {
          console.log("Iframe is allowed (same origin)");
        } else {
          console.warn(
            "Clickjacking Protection: Blocking unauthorized iframe!"
          );

          // Remove all content and display a warning message
          document.body.innerHTML =
            "<h1 style='color:red; text-align:center; margin-top:20%;'>Clickjacking Protection: This site cannot be embedded.</h1>";
        }
      }
    } catch (error) {
      console.warn("Could not verify iframe origin. Blocking iframe.", error);
      document.body.innerHTML =
        "<h1 style='color:red; text-align:center; margin-top:20%;'>Clickjacking Protection: This site cannot be embedded.</h1>";
    }
  }, []);
  */

  return (
    <Suspense
    // fallback={<Spinner />}
    >
      {/* <Loader /> */}
      <ThemeProvider theme={portalTheme}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          {/* <ErrorBoundary> */}
          <Router>
            <AppRouting />
          </Router>
          {/* </ErrorBoundary> */}
        </LocalizationProvider>
      </ThemeProvider>
    </Suspense>
  );
}
export default App;
